export function fetcher<T>(url: string) {
  return fetch(`${process.env.NEXT_PUBLIC_API_PUBLIC}${url}`)
    .then((res) => res.json() as T)
    .catch(() => null);
}